module.exports = __webpack_public_path__ + "img/Component 87 – 98.c75e6a3b.png";